import { cn } from 'lib/utils';
import React from 'react';

interface FinishingDotItemProps {
  className?: string;
  label: string;
  align?: 'left' | 'right';
}

export const FinishingDotItem = ({
  className,
  label,
  align,
}: FinishingDotItemProps) => {
  return (
    <div
      className={cn(
        'group absolute size-6 hover:z-10 screen-500:size-3',
        className
      )}
    >
      <div className="absolute z-[2] top-1/2 -translate-y-1/2 left-0 size-6 rounded-full bg-plt-secondary screen-500:size-3"></div>
      <span
        className={cn(
          'text-sm opacity-0 hidden transition-opacity group-hover:opacity-100 group-hover:block absolute z-[1] -top-[6px] bg-plt-white rounded-full text-nowrap p-2 screen-500:p-1 screen-500:text-[10px] screen-500:-top-[8px]',
          align === 'left'
            ? 'pr-9 -right-1.5 screen-500:pr-5'
            : 'pl-9 -left-1.5 screen-500:pl-5'
        )}
      >
        {label}
      </span>
    </div>
  );
};
